<template>
  <div class="route-view has-top dark">
    <wallet />

    <CarouselAccount type="slotAccount" :modalSlot="modalSlot" />
    <CarouselAccount type="sportAccount" :modalSlot="modalSlot" />
    <CarouselAccount type="lottoAccount" :modalSlot="modalSlot" />

    <modal-slot-account
      v-if="modalSlotActive"
      :is-active="modalSlotActive"
      :selected-slot="selectedSlot"
      :wallet="total"
      @closeModal="modalSlotAndRefresh(true)"
    />
    <modal-agreement
      v-if="modalAgreementActive"
      :is-active="modalAgreementActive"
      @closeModal="modalAgreement"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { isRememberAgreement } from '@/utils/agreement'

import ModalSlotAccount from '@/views/user/components/modals/SlotAccount'
import ModalAgreement from '@/views/user/components/modals/Agreement'

import CarouselAccount from '@/components/CarouselAccount.vue'
import Wallet from '@/components/Wallet.vue'

export default {
  name: 'UserHome',
  components: {
    ModalSlotAccount,
    ModalAgreement,
    Wallet,
    CarouselAccount
  },
  props: {
    page: String
  },
  data() {
    return {
      selectedSlot: {},
      modalSlotActive: false,
      modalAgreementActive: false
    }
  },
  computed: {
    ...mapState({
      total: store => store.userInfo.total
    })
  },
  created() {
    this.$emit('childinit', this.page)
  },
  mounted() {
    if (!isRememberAgreement()) {
      setTimeout(() => {
        this.modalAgreementActive = true
      }, 1500)
    }
  },
  methods: {
    ...mapActions('userInfo', ['getUserWallet']),
    modalSlot(slot) {
      this.modalSlotActive = !this.modalSlotActive
      this.disabledBodyScroll(this.modalSlotActive)

      if (slot) this.selectedSlot = slot
      else this.selectedSlot = {}
    },
    modalSlotAndRefresh(isSaved) {
      this.modalSlot()

      if (isSaved === true) {
        this.getUserWallet(true)
      }
    },
    modalAgreement() {
      this.modalAgreementActive = !this.modalAgreementActive
      this.disabledBodyScroll(this.modalAgreementActive)
    },
    disabledBodyScroll(isModalShow) {
      if (isModalShow) document.documentElement.style.overflow = 'hidden'
      else document.documentElement.style.overflow = 'auto'
    }
  }
}
</script>
